'use strict';

var app = require('mag-app'),
    dom = require('spa-dom'),
    tag = dom.tag;


/**
 * Prepare data for series list.
 *
 * @param {Object} data - data to prepare
 *
 * @return {Array} prepared data
 */
module.exports =  function ( data ) {
    var disabled = false,
        result = [],
        $focusWrapper, $blurWrapper,
        $status, $title, statusText,
        $container;

    data.forEach(function ( item ) {
        disabled = false;
        item.type = app.config.types.series;
        item.custName = gettext('Series') + ' ' + item.number
            + (item.name
                ? ' - ' + item.name
                : item['original_name'] ? ' - ' +  item['original_name'] : '');

        switch ( item['watched_status'] ) {
            case 'watched':
                statusText = gettext('Watched');
                disabled = true;
                break;
            case 'not_watched':
                statusText = '';
                break;
            case 'not_ended':
                statusText = gettext('Not finished');
                break;
        }
        $title = tag('div', {className: 'itemTitle'}, item.custName);
        $status = tag('div', {className: 'itemStatus' + (disabled ? ' disabled' : '' )}, statusText);
        item.status = {};
        item.status.$focus = $status;
        $container = tag('div', {className: 'container'}, $title, $status);
        $focusWrapper = tag('div', {className: 'focusWrapper'}, $container);
        $title = tag('div', {className: 'itemTitle'}, item.custName);
        $status = tag('div', {className: 'itemStatus' + (disabled ? ' disabled' : '' )}, statusText);
        item.status.$blur = $status;
        $container = tag('div', {className: 'container'}, $title, $status);
        $blurWrapper = tag('div', {className: 'blurWrapper'}, $container);
        result.push({
            items: [
                $focusWrapper,
                $blurWrapper
            ],
            value: item
        });
    });

    return result;
};
